import { render, staticRenderFns } from "./sResult.vue?vue&type=template&id=4a46bade&scoped=true&"
import script from "./sResult.vue?vue&type=script&lang=js&"
export * from "./sResult.vue?vue&type=script&lang=js&"
import style0 from "./sResult.vue?vue&type=style&index=0&id=4a46bade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46bade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
